@file:OptIn(InternalResourceApi::class)

package ifaandroid.feature.today_v2.today_ui_common.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.feature.today_v2.today_ui_common.generated.resources/"

@delegate:ResourceContentHash(1_190_565_758)
internal val Res.drawable.ic_calendar: DrawableResource by lazy {
      DrawableResource("drawable:ic_calendar", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_calendar.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-993_363_418)
internal val Res.drawable.ic_charm_lightning_bolt: DrawableResource by lazy {
      DrawableResource("drawable:ic_charm_lightning_bolt", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_charm_lightning_bolt.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_068_243_073)
internal val Res.drawable.pcos_logo: DrawableResource by lazy {
      DrawableResource("drawable:pcos_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/pcos_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_355_797_351)
internal val Res.drawable.ptracker_bg: DrawableResource by lazy {
      DrawableResource("drawable:ptracker_bg", setOf(
        ResourceItem(setOf(), "${MD}drawable/ptracker_bg.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_calendar", Res.drawable.ic_calendar)
  map.put("ic_charm_lightning_bolt", Res.drawable.ic_charm_lightning_bolt)
  map.put("pcos_logo", Res.drawable.pcos_logo)
  map.put("ptracker_bg", Res.drawable.ptracker_bg)
}
